var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.105,
    height: 24.099,
    viewBox: "0 0 21.105 24.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2429",
    "data-name": "Group 2429",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 10.043,
    cy: 10.043,
    rx: 10.043,
    ry: 10.043,
    transform: "translate(0.02 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M429.09,1371.345a.845.845,0,1,0-.845.845A.865.865,0,0,0,429.09,1371.345Z",
    transform: "translate(-418.183 -1361.302)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1592",
    "data-name": "Line 1592",
    y2: 1.238,
    transform: "translate(10.062 1.356)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1593",
    "data-name": "Line 1593",
    x2: 1.218,
    transform: "translate(1.395 10.043)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1594",
    "data-name": "Line 1594",
    y1: 1.238,
    transform: "translate(10.062 17.472)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1595",
    "data-name": "Line 1595",
    x1: 1.218,
    transform: "translate(17.511 10.043)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1596",
    "data-name": "Line 1596",
    y1: 3.872,
    transform: "translate(10.062 5.326)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1597",
    "data-name": "Line 1597",
    x2: 3.852,
    transform: "translate(10.907 10.043)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1598",
    "data-name": "Line 1598",
    x1: 1.828,
    y1: 2.28,
    transform: "translate(14.543 20.616)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1599",
    "data-name": "Line 1599",
    x1: 1.808,
    y2: 2.28,
    transform: "translate(3.754 20.616)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M381.8,1430.4h-.334a.965.965,0,0,0-.963.963h0a.964.964,0,0,0,.963.963h18.179a.964.964,0,0,0,.963-.963h0a.965.965,0,0,0-.963-.963h-.334",
    transform: "translate(-380.5 -1409.43)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M418.044,1359.817a2.711,2.711,0,1,1-3.42-3.42v-1.3a3.966,3.966,0,1,0,4.717,4.717h-1.3Z",
    transform: "translate(-405.408 -1348.929)",
    fill: "#ff2c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M442.057,1334.879a.079.079,0,1,0-.079.079C442.018,1334.938,442.057,1334.918,442.057,1334.879Z",
    transform: "translate(-429.833 -1332.619)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M420.865,1334.867c-.02-.039-.059-.039-.1-.02s-.039.059-.02.1.059.039.1.02A.086.086,0,0,0,420.865,1334.867Z",
    transform: "translate(-412.827 -1332.646)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M410.938,1338.94a.07.07,0,1,0,0,.1A.056.056,0,0,0,410.938,1338.94Z",
    transform: "translate(-404.865 -1335.933)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M402.465,1345.467a.086.086,0,0,0-.1.02c-.02.02,0,.078.02.1a.086.086,0,0,0,.1-.02C402.5,1345.545,402.485,1345.486,402.465,1345.467Z",
    transform: "translate(-398.063 -1341.182)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M395.877,1353.879c-.039-.02-.079.02-.1.059s.02.078.059.1.079-.02.1-.059A.108.108,0,0,0,395.877,1353.879Z",
    transform: "translate(-392.772 -1347.943)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M391.779,1363.8a.079.079,0,1,0,.079.079C391.838,1363.82,391.818,1363.8,391.779,1363.8Z",
    transform: "translate(-389.499 -1355.919)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M391.767,1385.047c-.039.02-.039.059-.02.1s.059.039.1.02.039-.059.02-.1S391.806,1385.028,391.767,1385.047Z",
    transform: "translate(-389.526 -1372.98)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M395.84,1394.94a.07.07,0,1,0,.1,0A.088.088,0,0,0,395.84,1394.94Z",
    transform: "translate(-392.813 -1380.927)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M402.367,1403.432a.071.071,0,1,0,.1-.02C402.426,1403.373,402.386,1403.393,402.367,1403.432Z",
    transform: "translate(-398.063 -1387.729)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M410.779,1409.938c-.02.039.02.078.059.1s.079-.02.1-.059-.02-.079-.059-.1S410.8,1409.9,410.779,1409.938Z",
    transform: "translate(-404.824 -1392.938)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M420.7,1414.079a.079.079,0,1,0,.079-.079A.085.085,0,0,0,420.7,1414.079Z",
    transform: "translate(-412.799 -1396.253)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M441.947,1414.146c.02.039.059.039.1.02s.039-.059.02-.1-.059-.039-.1-.02C441.927,1414.047,441.927,1414.106,441.947,1414.146Z",
    transform: "translate(-429.861 -1396.281)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M451.84,1410.038a.07.07,0,1,0,0-.1A.088.088,0,0,0,451.84,1410.038Z",
    transform: "translate(-437.807 -1392.979)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M460.332,1403.585a.071.071,0,1,0-.02-.1C460.273,1403.526,460.293,1403.565,460.332,1403.585Z",
    transform: "translate(-444.61 -1387.784)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M466.859,1394.936c.039.02.079-.02.1-.059s-.02-.079-.059-.1-.079.02-.1.059C466.8,1394.9,466.82,1394.936,466.859,1394.936Z",
    transform: "translate(-449.839 -1380.805)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M470.979,1385.157a.079.079,0,1,0-.079-.079A.085.085,0,0,0,470.979,1385.157Z",
    transform: "translate(-453.134 -1372.953)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M471.045,1363.965c.039-.02.039-.059.02-.1s-.059-.039-.1-.02-.039.059-.02.1A.086.086,0,0,0,471.045,1363.965Z",
    transform: "translate(-453.161 -1355.947)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M466.938,1354.038a.069.069,0,1,0-.1,0C466.879,1354.077,466.918,1354.077,466.938,1354.038Z",
    transform: "translate(-449.859 -1347.985)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M460.485,1345.565a.086.086,0,0,0-.02-.1c-.02-.02-.079,0-.1.02a.071.071,0,0,0,.118.078Z",
    transform: "translate(-444.664 -1341.182)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M451.836,1338.977c.02-.039-.02-.079-.059-.1s-.079.02-.1.059.02.079.059.1C451.8,1339.036,451.836,1339.016,451.836,1338.977Z",
    transform: "translate(-437.686 -1335.891)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.ea0d1b72fd0a21bc4aa395f2d90b30ca.svg";
export { ForwardRef as ReactComponent };